// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"a867bdd7c0--wrapper--Oh_fF","link":"a867bdd7c0--link--tDZ1W"};